module.exports = __webpack_public_path__ + "img/placeholder-cashFlow.159584bb.png";